import { render } from "./JourneyComponent.vue?vue&type=template&id=71a8e66c&scoped=true&ts=true"
import script from "./JourneyComponent.ts?vue&type=script&lang=ts"
export * from "./JourneyComponent.ts?vue&type=script&lang=ts"

import "./JourneyComponent.scss?vue&type=style&index=0&id=71a8e66c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/maximum/maximum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a8e66c"]])

export default __exports__